import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/theme-chalk/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
// 导入 i18n 配置
import i18n from "./locales";
// 导入 Element Plus 的语言包
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import en from "element-plus/dist/locale/en.mjs";

// 创建应用实例
const app = createApp(App).use(store).use(router).use(ElementPlus).use(i18n);

// 全局注册 Element+ 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 设置 Element Plus 的初始语言
app.config.globalProperties.$ELEMENT = {
  locale: i18n.global.locale.value === "zh" ? zhCn : en,
};

app.mount("#app");
